import { readonly } from 'vue'
import state from './state'
import getters from './getters'

/**
 * Readable state plus getters, deliberately without mutations so consumers cannot write
 * directly. `state` is a getter because the underlying accessor resolves per request on the
 * server.
 */
export default {
  get state () {
    return readonly(state())
  },
  getters
}
